export enum ApprovalFlowStatus {
    PositiveStatus = 'positiveStatus',
    NegativeStatus = 'negativeStatus',
}
